import { Plugins, Match } from '@leverege/plugin'

function createMatch( objectType, path, client ) {
  return {
    objectType,
    path,
    client
  }
}

export function getQueryHandlers( { objectType, path, client, relationship, caches } ) {
  return caches.calc( 'queryPlugins', () => {
    const matches = createMatch( objectType, path, client )
    const v = Plugins.createView( 'EventQueryOptionsHandler', {
      name : relationship.urlPath,
      filter : plg => Match.isMatch( matches, plg.matches )
    } )

    return v.get()
  }, objectType, path, client, relationship, Plugins.getVersion( 'EventQueryOptionsHandler' ) )
}

export function getQueryHandlerResults( opts, cxt ) {
  const handlers = getQueryHandlers( opts )

  return handlers
    .sort( numSortComparator )[0]?.handle( cxt )
}

function numSortComparator( a, b ) {
  const an = a.sort || 0
  const bn = b.sort || 0
  return an - bn
}
